import { makeStyles } from '@material-ui/core/styles';

export const editReportStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(4)
  },
  container: {
    width: 800,
    margin: theme.spacing(2),
    padding: theme.spacing(2)
  },
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2)
  },
  margin: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  addUsersHeading: {
    fontSize: '1.25rem',
    fontWeight: 600
  },
  currentUsersContainer: {
    maxHeight: 250,
    overflowY: 'scroll',
    marginTop: theme.spacing(2)
  },
  userRow: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    }
  }
  // errorText: {
  //   color: '#f44336',
  //   textAlign: 'center',
  //   display: 'block',
  //   margin: theme.spacing(3)
  // }
}));
